import React, { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, FormHelperText } from '@mui/material';
import { useIntl } from 'react-intl';
import HCaptchaInput from '@hcaptcha/react-hcaptcha';

const HCaptcha = forwardRef(({ control, error, helperText }: any, ref) => {
  const { locale: lang, formatMessage } = useIntl();

  return (
    <Controller
      control={control}
      name="hcaptcha_token"
      rules={{
        required: formatMessage({ id: 'AUTH.ERRORS.REQUIRED_CHECKBOX' }),
      }}
      render={({ field: { onChange } }: any) => (
        <FormControl error={error}>
          <HCaptchaInput
            sitekey={window.runtimeEnv?.REACT_APP_HCAPTCHA_KEY}
            onVerify={onChange}
            // @ts-expect-error No overload matches this call.
            ref={ref}
            languageOverride={lang}
          />
          {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    />
  );
});

HCaptcha.displayName = 'HCaptcha';

export default HCaptcha;
